// extracted by mini-css-extract-plugin
module.exports = {"root":"RemoveFileBtn_root__2HViP"};